import { ApproveComponent } from './../approve/approve.component';
import { Component, OnInit } from '@angular/core';
import { CommentsService } from '../Services/comments.service';
import { GamesService } from '../Services/games.service';
@Component({
  selector: 'app-commentcontrol',
  templateUrl: './commentcontrol.component.html',
  styleUrls: ['./commentcontrol.component.css']
})
export class CommentcontrolComponent implements OnInit {
  user_id: string;
  comments_list: any;
  show:boolean=true;
  showtext:string;
  constructor(private comments: CommentsService, private games:GamesService) {

    this.user_id = localStorage.getItem('user_id');
    this.getComments();
  }


  ngOnInit() {
  }
  getComments() {
    this.comments.getcomments(this.user_id).subscribe(
      next => {
        console.log(next);
        this.comments_list = next['list'];
      },
      error => {
        console.log(error);
      }
    )

  }
  CommentApprove(comment_id){
    
  
  this.games.approveComment(comment_id).subscribe(
    next=>{
      console.log(next);
      this.show=false;
      this.showtext="Comment Approved";
      this.comments_list.forEach(element=>{
        if(element.comment_id==comment_id){
          element.approved=true;
        }
      })

    },
    error=>{
      console.log(error);
    }
  )

  }

  Commentdelete(comment_id){
    
  
    this.games.deleteComment(comment_id).subscribe(
      next=>{
        console.log(next);
        this.show=false;
        this.showtext="Comment Deleted";

        this.comments_list.forEach(element=>{
          if(element.comment_id==comment_id){
            element.approved=true;
          }
        })

      },
      error=>{
        console.log(error);
      }
    )
  
    }
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/commentcontrol/commentcontrol.component.ts